import { ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

export default function useAppCustomizer() {
  // Customizer
  const isCustomizerOpen = ref(false)

  // Skin
  const skinOptions = [
    { text: 'Clair', value: 'light' },
    { text: 'Mini', value: 'bordered' },
    { text: 'Sombre', value: 'dark' },
    { text: 'Mi-sombre', value: 'semi-dark' },
  ]

  // Content Width Options
  const contentWidthOptions = [
    { text: 'Plein ecran', value: 'full' },
    { text: 'Fenetré', value: 'boxed' },
  ]

  // Router Transition
  const routerTransitionOptions = [
    { title: 'Zoom fondu', value: 'zoom-fade' },
    { title: 'Fondu', value: 'fade' },
    { title: 'Fondu vertical', value: 'fade-bottom' },
    { title: 'Fondu latéral', value: 'slide-fade' },
    { title: 'Dézoome', value: 'zoom-out' },
    { title: 'Aucun', value: 'none' },
  ]

  // Router Transition
  const layoutTypeOptions = [
    { text: 'Vertical', value: 'vertical' },
    { text: 'Horizontal', value: 'horizontal' },
  ]

  // Navbar
  const navbarColors = ['', 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark']

  // Navbar Types
  const navbarTypes = [
    { text: 'Flottant', value: 'floating' },
    { text: 'Statique', value: 'static' },
    { text: 'Masquée', value: 'hidden' },
  ]

  // Footer Types
  const footerTypes = [
    { text: 'Collant', value: 'sticky' },
    { text: 'Statique', value: 'static' },
    { text: 'Masqué', value: 'hidden' },
  ]

  // eslint-disable-next-line object-curly-newline
  const {
    isRTL,
    skin,
    contentWidth,
    routerTransition,
    layoutType,
    isNavMenuHidden,
    isVerticalMenuCollapsed,
    navbarBackgroundColor,
    navbarType,
    footerType,
  } = useAppConfig()

  return {
    // Customizer
    isCustomizerOpen,

    // Vertical Menu
    isVerticalMenuCollapsed,

    // Skin
    skin,
    skinOptions,

    // Content Width
    contentWidth,
    contentWidthOptions,

    // RTL
    isRTL,

    // routerTransition
    routerTransition,
    routerTransitionOptions,

    // Layout Type
    layoutType,
    layoutTypeOptions,

    // NavMenu Hidden
    isNavMenuHidden,

    // Navbar
    navbarColors,
    navbarTypes,
    navbarBackgroundColor,
    navbarType,

    // Footer
    footerTypes,
    footerType,
  }
}
